
















import {Component, Vue, Prop} from "vue-property-decorator";
import CalendarEventObj from "../models/CalendarEvent";
import {MINUTES, PIXELS} from "../utils";

@Component({})
export default class CalendarEvent extends Vue {
    @Prop() protected event!: CalendarEventObj;
    @Prop({default: false}) protected admin!: boolean;

    get styleTop() {
        return this.event.start.minute() + PIXELS;
    }

    get styleHeight() {
        return this.event.finish.diff(this.event.start, MINUTES) + PIXELS;
    }

    protected onRootMouseOver(evt: MouseEvent) {
        const resizeLambda = () => {
            (this.$refs.root as HTMLDivElement).style.minHeight =
                ((this.$refs.fullDetailDiv as HTMLDivElement).offsetHeight + 10) + PIXELS;
        };
        setTimeout(resizeLambda, 200);
        setTimeout(resizeLambda, 400);
    }

    protected onRootMouseOut(evt: MouseEvent) {
        (this.$refs.root as HTMLDivElement).style.minHeight = 30 + PIXELS;
    }

    protected onEventClicked(evt: MouseEvent) {
        if (this.admin) {
            window.location = ("/event/?eid=" + this.event.id) as unknown as Location;
        } else {
            alert(this.event.name + "\n" +
                this.event.start.format("h:mm A") + " to " + this.event.finish.format("h:mm A") +
                "\n" + this.event.detail);
        }
    }
}
